import React, { useContext, useEffect, useState } from "react";
import {
  Alert,
  Button,
  Container,
  Modal,
  Form,
  Table,
  Pagination,
  Spinner,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { UserContext } from "../../../contexts/UserContext";
import AxiosController from "../../../authentication/AxiosController";
import Loader from "../../../loader/Loader";
import { IconTrash } from "@tabler/icons-react";


const AddOrderFulfillment = () => {
  const { slug, lang, productId, variant } = useParams();
  const Navigate = useNavigate();
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  if (token) {
  } else {
    Navigate(`/ar/auth/login`);
  }
  const [_] = useTranslation("global");
  const [cart, handleCart] = useState([]);
  const [governments, handleGovs] = useState([]);
  // const [governmentAreas, handleGovAreas] = useState([]);
  const [loading, handleLoader] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [modalLoading, setModalLoading] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [productVariants, setProductVariants] = useState([]);
  const [selectedProductVariants, setSelectedProductVariants] = useState({});
  const [productVariantsByProductId, setProductVariantsByProductId] = useState({});

  const [shippingcost, handleShippingCost] = useState(0);

  // order data
  const [orderClientName, handleOrderClientName] = useState("");
  const [altName, setAltname] = useState("");
  const [orderClientNameErr, handleOrderClientNameErr] = useState("");
  const [orderClientPhone1, handleOrderClientPhone1] = useState("");
  const [orderClientPhone1Err, handleOrderClientPhone1Err] = useState("");
  const [orderClientPhone2, handleOrderClientPhone2] = useState("");
  const [orderClientGov, handleOrderClientGov] = useState(0);
  const [orderClientQuantity, handleOrderClientQuantity] = useState(1);
  const [orderClientPrice, handleOrderClientPrice] = useState(0);
  const [selectedProductQuantities, setSelectedProductQuantities] = useState(
    {}
  );
  const [selectedProductPrices, setSelectedProductPrices] = useState({});
  const [orderClientGovErr, handleOrderClientGovErr] = useState("");
  const [orderClientAddress, handleOrderClientAddress] = useState("");
  const [orderClientAddressErr, handleOrderClientAddressErr] = useState("");
  const [orderClientPublicNotes, handleOrderClientPublicNotes] = useState("");
  const [orderClientPrivateNotes, handleOrderClientPrivateNotes] = useState("");
  const [orderLink, setOrderLink] = useState("");
  const [COD, setCOD] = useState(0);
  const [zeroCOD, setZeroCOD] = useState(false);
  const [orderLinkErr, setOrderLinkErr] = useState("");
  const [ref_order, setRef_order] = useState("");
  const [ref_orderErr, setRef_orderErr] = useState("");
  const { userData } = useContext(UserContext);

  // Calculate total price for multiple products
  const calculateTotalPrice = () => {
    if (selectedProducts.length === 0) {
      return orderClientPrice * orderClientQuantity;
    }

    let total = 0;
    selectedProducts.forEach((productId) => {
      const quantity = selectedProductQuantities[productId] || 1;
      const price = selectedProductPrices[productId] || 0;
      total += price * quantity;
    });
    return total;
  };

  const totalPrice = calculateTotalPrice();

  // Calculate total commission for multiple products
  const calculateTotalCommission = () => {
    if (selectedProducts.length === 0) {
      return (
        (orderClientPrice -
          (cart.price - (userData?.level_data?.commission ?? 0))) *
        orderClientQuantity
      );
    }

    let totalCommission = 0;
    selectedProducts.forEach((productId) => {
      const product = products.find((p) => p.id === productId);
      if (product) {
        const quantity = selectedProductQuantities[productId] || 1;
        const price = selectedProductPrices[productId] || product.price;
        totalCommission +=
          (price - (product.price - (userData?.level_data?.commission ?? 0))) *
          quantity;
      }
    });
    return totalCommission;
  };

  const totalCommission = calculateTotalCommission();
  useEffect(() => {
    handleLoader(true);

    // Only fetch variant details if variant is provided
    if (variant) {
      AxiosController.get(
        `api/${slug}/${lang}/get-variant-details/${variant}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
        .then((res) => {
          if (!res.data) Navigate(`/${slug}/${lang}`);
          handleCart(res.data);
          setAltname(res.data.alt_name ? res.data.alt_name.split(" ")[0] : "");
          handleOrderClientPrice(res.data.price);
          handleLoader(false);
        })
        .catch((e) => {
          handleLoader(false);
        });
    } else {
      handleLoader(false);
    }

    // Always fetch shipping costs
    AxiosController.get(`api/${slug}/${lang}/get-shippingcost`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        handleGovs(res.data);
        handleShippingCost(res.data[0].cost);
        handleLoader(false);
      })
      .catch((e) => {
        handleLoader(false);
      });
  }, [slug, lang, token, variant]);
  const placeOrder = () => {
    handleLoader(true);

    // Prepare variants array based on selection
    let variants = [];

    if (selectedProducts.length > 0) {
      // Multiple products selected
      selectedProducts.forEach((productId) => {
        const product = products.find((p) => p.id === productId);
        if (product) {
          const quantity = selectedProductQuantities[productId] || 1;
          const variantList = productVariantsByProductId[productId] || [];
          const selectedVariant = variantList.find(v => v.id === selectedProductVariants[productId]);
          const price = selectedVariant ? parseFloat(selectedVariant.price) : 0;
          variants.push({
            v_id: selectedProductVariants[productId],
            price: price, // this can be 0
            quantity: quantity,
          });
        }
      });
    } else {
      // Single product (original behavior)
      variants = [
        {
          v_id: variant,
          price: orderClientPrice || 1,
          quantity: orderClientQuantity,
        },
      ];
    }

    AxiosController.post(
      `api/${slug}/${lang}/place-order/`,
      {
        customer_name: orderClientName,
        phone_1: orderClientPhone1,
        phone_2: orderClientPhone2,
        gov_id: orderClientGov,
        public_notes: orderClientPublicNotes,
        private_notes: orderClientPrivateNotes,
        address: orderClientAddress,
        order_link: orderLink,
        COD: COD,
        reference_order: ref_order,
        variants: variants,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => {
        handleLoader(false);
        Navigate(`/${slug}/${lang}/success-order`);
      })
      .catch((e) => {
        const err = e.response?.data?.error;
        if (typeof err === "string") {
          handleLoader(false);
          return;
        }
        toast.error(err);
        handleOrderClientNameErr(
          e.response.data.error.customer_name
            ? e.response.data.error.customer_name[0]
            : ""
        );
        handleOrderClientPhone1Err(
          e.response.data.error.phone_1 ? e.response.data.error.phone_1[0] : ""
        );
        handleOrderClientGovErr(
          e.response.data.error.gov_id ? e.response.data.error.gov_id[0] : ""
        );
        handleOrderClientAddressErr(
          e.response.data.error.address ? e.response.data.error.address[0] : ""
        );
        setOrderLinkErr(
          e.response.data.error.order_link
            ? e.response.data.error.order_link[0]
            : ""
        );
        handleLoader(false);
      });
  };

  const fetchProducts = async (page = 1, search = "") => {
    setModalLoading(true);
    try {
      const response = await AxiosController.get(
        `api/${slug}/${lang}/latest-products/${page}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            name: search,
            code: "",
            user_id: "",
            start_date: "",
            end_date: "",
            status: "",
            sysCommission: "",
            sellerCommission: "",
            sku: "",
            category_id: "",
          },
        }
      ); 

      if (response.data && response.data.payment_requests) {
        setProducts(response.data.payment_requests.data || []);
        setTotalPages(response.data.payment_requests.last_page || 1);
        setCurrentPage(page);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      toast.error(_("panel.errorLoadingProducts"));
    } finally {
      setModalLoading(false);
    }
  };

  const fetchProductDetails = async (productId) => {
    try {
      const response = await AxiosController.get(
        `https://api.ecombo.co/api/ae/ar/get-product/${productId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data && response.data.product_variants) {
        setProductVariants(response.data.product_variants);
        // You can also use response.data.alt_name, etc.
      }
    } catch (error) {
      toast.error("Error fetching product details");
    }
  };

  const handleProductSelect = (product) => {
    if (product && product.id) {
      handleCart(product);
      setAltname(product.alt_name ? product.alt_name.split(" ")[0] : "");
      handleOrderClientPrice(product.price || 0);
      setShowProductModal(false);
      setSearchTerm("");
      setSelectedProducts([]);
      fetchProductDetails(product.id); // <-- Fetch variants here
    }
  };

  const handleCheckboxChange = (productId, checked) => {
    if (checked) {
      setSelectedProducts((prev) => [...prev, productId]);
    } else {
      setSelectedProducts((prev) => prev.filter((id) => id !== productId));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const availableProductIds = products
        .filter((product) => product.id && product.left > 0)
        .map((product) => product.id);
      setSelectedProducts(availableProductIds);
    } else {
      setSelectedProducts([]);
    }
  };

  const fetchVariantsForProducts = async (productIds) => {
    const variantsMap = {};
    for (const productId of productIds) {
      try {
        const response = await AxiosController.get(
          `https://api.ecombo.co/api/ae/ar/get-product/${productId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.data && response.data.product_variants) {
          variantsMap[productId] = response.data.product_variants;
        }
      } catch (error) {
        variantsMap[productId] = [];
      }
    }
    setProductVariantsByProductId((prev) => ({ ...prev, ...variantsMap }));
    return variantsMap; // <-- return the map
  };

  const handleConfirmSelection = async () => {
    if (selectedProducts.length === 0) {
      toast.error(_("panel.pleaseSelectAtLeastOneProduct"));
      return;
    }

    const variantsMap = await fetchVariantsForProducts(selectedProducts);

    // Initialize quantities and prices for selected products
    const newQuantities = {};
    const newPrices = {};
    const newVariants = {};

    selectedProducts.forEach((productId) => {
      const product = products.find((p) => p.id === productId);
      if (product) {
        const variants = variantsMap[productId] || [];
        const selectedVariant = variants.length > 0 ? variants[0] : null;
        newQuantities[productId] = 1; // Default quantity
        newPrices[productId] = selectedVariant ? parseFloat(selectedVariant.price) : 0;
        newVariants[productId] = selectedVariant ? selectedVariant.id : null;
      }
    });

    setSelectedProductQuantities(newQuantities);
    setSelectedProductPrices(newPrices);
    setSelectedProductVariants(newVariants);
    setShowProductModal(false);
    setSearchTerm("");
  };

  const handleSearch = () => {
    fetchProducts(1, searchTerm);
  };

  const handlePageChange = (page) => {
    fetchProducts(page, searchTerm);
  };

  return (
    <Container style={{ position: "relative" }}>
      <Loader active={loading} />
      <Helmet>
        <title> {_("panel.addOrder")}</title>
      </Helmet>
      <div className="add-product-container d-flex flex-column gap-2 my-3 px-2 px-md-4">
        <div className="add-header" dir={lang === "en" ? "ltr" : "rtl"}>
          <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mb-3">
            <h2 style={{ color: "rgba(89, 198, 201, 1)" }} className="mb-0 fs-4 fs-md-3">
              {_("panel.addOrder")}
            </h2>
          </div>
        </div>
        <div
          className="d-flex gap-3 gap-md-5 flex-column-reverse flex-xl-row"
          dir={lang === "en" ? "ltr" : "rtl"}
        >
          <div
            className="order-right-container d-flex flex-column"
            style={{ flex: "7" }}
          >
            <div className="order-right-entry">
              <div className="add-body1 d-flex flex-column gap-4 mb-4">
                <div
                  className="right-side d-flex flex-column"
                >
                  <div className="right-head">
                    <h3 className="fs-4 fs-md-3">{_("home.customerdetails")}</h3>
                    <p className="text-muted small">{_("home.verifydata")}</p>
                  </div>
                  <div className="mb-3">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        {_("panel.orderLink")}
                      </label>
                      {orderLinkErr ? (
                        <Alert variant={"danger"}>{ref_orderErr}</Alert>
                      ) : (
                        ""
                      )}
                      <input
                        type="text"
                        className="form-control py-2 px-3 egp"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        value={ref_order}
                        onInput={(e) => setRef_order(e.target.value)}
                      />
                    </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.fullname")}
                    </label>
                    {orderClientNameErr ? (
                      <Alert variant={"danger"}>{orderClientNameErr}</Alert>
                    ) : (
                      ""
                    )}
                    <input
                      type="text"
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      value={orderClientName}
                      onInput={(e) => handleOrderClientName(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.phonenumber")}
                    </label>
                    {orderClientPhone1Err ? (
                      <Alert variant={"danger"}>{orderClientPhone1Err}</Alert>
                    ) : (
                      ""
                    )}
                    <input
                      type="text"
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      value={orderClientPhone1}
                      onInput={(e) => handleOrderClientPhone1(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.phonenumber2")}
                    </label>
                    <input
                      type="text"
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      value={orderClientPhone2}
                      onInput={(e) => handleOrderClientPhone2(e.target.value)}
                    />
                  </div>
                  {selectedProducts.length === 0 ? (
                    <div className="mb-3">
                      <div className=" ">
                        {/* <div className="flex-grow-1">
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label"
                          >
                            {_("home.quantity")}
                          </label>
                          <input
                            type="number"
                            className="form-control py-2 px-3 egp"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            value={orderClientQuantity}
                            onInput={(e) =>
                              handleOrderClientQuantity(e.target.value)
                            }
                          />
                        </div> */}
                    
                          <div className="flex-grow-1 mt-4">
                            <div className="d-flex justify-content-between align-items-center ">
                           <label className="form-label">{_("panel.zeroCOD")}</label>
                              <Form.Check // prettier-ignore
                                type="switch"
                                id="custom-switch"
                                label=''
                                className="border-0 mb-0 "
                                value={zeroCOD}
                                onInput={(e) => {
                                  setZeroCOD((value) => {
                                    if (!value) {
                                      setCOD(0);
                                    }
                                    return !value;
                                  });
                                }}
                              />
                            </div>
                          </div>
                       </div>
                      {role === "fulfillment" && (
                        <div className=" mt-4"> 
                          <label
                            htmlFor="exampleInputEmail1"
                            className="form-label"
                          >
                            {_("home.COD")}
                          </label>
                          <input
                            type="number"
                            className="form-control py-2 px-3 egp"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            value={COD}
                            disabled={zeroCOD}
                            onInput={(e) => setCOD(e.target.value)}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="mb-3">
                      <label className="form-label fw-bold">
                        {_("panel.selectedProducts")} ({selectedProducts.length}
                        )
                      </label>
                      <div className="border rounded p-3 bg-light">
                        {selectedProducts.map((productId) => {
                          const product = products.find(
                            (p) => p.id === productId
                          );
                          if (!product) return null;

                          return (
                            <div
                              key={productId}
                              className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-3 mb-3 p-2 border-bottom"
                            >
                              <div className="d-flex align-items-center gap-2">
                                <img
                                  src={product.thumbnail}
                                  alt={product.title || product.name}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                  }}
                                  className="img-thumbnail"
                                />
                                <div className="flex-grow-1">
                                  <strong className="d-block text-break">
                                    {product.title || product.name}
                                  </strong>
                                  <small className="text-muted">
                                    SKU: {product.sku || "-"}
                                  </small>
                                </div>
                              </div>
                              <div className="d-flex flex-column flex-sm-row gap-2 align-items-start align-items-sm-center w-100 w-sm-auto">
                                <div style={{ width: "80px" }}>
                                  <label className="form-label small mb-1">
                                    {_("home.quantity")}
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={
                                      selectedProductQuantities[productId] || 1
                                    }
                                    onChange={(e) => {
                                      const newQuantities = {
                                        ...selectedProductQuantities,
                                      };
                                      newQuantities[productId] =
                                        parseInt(e.target.value) || 1;
                                      setSelectedProductQuantities(
                                        newQuantities
                                      );
                                    }}
                                    min="1"
                                  />
                                </div>
                                {role !== "fulfillment" && (
                                  <div style={{ width: "100px" }}>
                                    <label className="form-label small mb-1">
                                      {_("home.price")}
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm"
                                      value={
                                        selectedProductPrices[productId] ||
                                        product.price
                                      }
                                      onChange={(e) => {
                                        const newPrices = {
                                          ...selectedProductPrices,
                                        };
                                        newPrices[productId] =
                                          parseFloat(e.target.value) ||
                                          product.price;
                                        setSelectedProductPrices(newPrices);
                                      }}
                                      min={product.price}
                                    />
                                  </div>
                                )}
                                <button
                                  size="sm"
                                  className="mt-4 btn text-danger"
                                  onClick={() => {
                                    setSelectedProducts((prev) =>
                                      prev.filter((id) => id !== productId)
                                    );
                                    const newQuantities = {
                                      ...selectedProductQuantities,
                                    };
                                    const newPrices = {
                                      ...selectedProductPrices,
                                    };
                                    const newVariants = {
                                      ...selectedProductVariants,
                                    };
                                    delete newQuantities[productId];
                                    delete newPrices[productId];
                                    delete newVariants[productId];
                                    setSelectedProductQuantities(newQuantities);
                                    setSelectedProductPrices(newPrices);
                                    setSelectedProductVariants(newVariants);
                                  }}
                                >
                                  <IconTrash size={16} />
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      {role === "fulfillment" && (
                        <div className="mt-3">
                          <div className="d-flex align-items-center gap-3 mb-3">
                            <Form.Check // prettier-ignore
                              type="switch"
                              id="custom-switch-selected"
                              label={_("panel.zeroCOD")}
                              className="border-0 mb-0"
                              value={zeroCOD}
                              onInput={(e) => {
                                setZeroCOD((value) => {
                                  if (!value) {
                                    setCOD(0);
                                  }
                                  return !value;
                                });
                              }}
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="exampleInputEmail1"
                              className="form-label"
                            >
                              {_("home.COD")}
                            </label>
                            <input
                              type="number"
                              className="form-control py-2 px-3 egp"
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                              value={COD}
                              disabled={zeroCOD}
                              onInput={(e) => setCOD(e.target.value)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="order-right-entry">
              <div className="add-body1 d-flex flex-column gap-4 mb-4">
                <div
                  className="right-side d-flex flex-column"
                >
                  <div className="right-head">
                    <h3 className="fs-4 fs-md-3">{_("home.shippingdetails")}</h3>
                    <p className="text-muted small">{_("home.verifydata")}</p>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.province")}
                    </label>
                    {orderClientGovErr ? (
                      <Alert variant={"danger"}>{orderClientGovErr}</Alert>
                    ) : (
                      ""
                    )}
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      onChange={(e) => {
                        handleOrderClientGov(
                          e.target.options[e.target.selectedIndex].id
                        );
                        handleShippingCost(e.target.value);
                      }}
                    >
                      <option value={0}></option>
                      {governments.map((gov) => {
                        return (
                          <option value={gov.cost} id={gov.id}>
                            {gov.arabic_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.address")}
                    </label>
                    {orderClientAddressErr ? (
                      <Alert variant={"danger"}>{orderClientAddressErr}</Alert>
                    ) : (
                      ""
                    )}
                    <textarea
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      rows="4"
                      value={orderClientAddress}
                      onInput={(e) => handleOrderClientAddress(e.target.value)}
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.notesforclient")}
                    </label>
                    <textarea
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      rows="4"
                      value={orderClientPublicNotes}
                      onInput={(e) =>
                        handleOrderClientPublicNotes(e.target.value)
                      }
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.notesformangment")}
                    </label>
                    <textarea
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      rows="4"
                      value={orderClientPrivateNotes}
                      onInput={(e) =>
                        handleOrderClientPrivateNotes(e.target.value)
                      }
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="order-info d-flex flex-column gap-3"
            style={{ height: "100%", flexGrow: 1 }}
          >
            <div
              className="left-side d-flex flex-column align-items-center text-center py-3 py-md-4 px-2 px-md-4 gap-2"
              style={{ height: "100%", flexGrow: 1, width: "100%" }}
            >
              <div className="top py-3">
                <h3>{_("home.ordersummary")}</h3>
               
              </div>
              <div
                className="left-body py-2 d-flex flex-column gap-3"
                style={{ minWidth: "100%" }}
              >
                {selectedProducts.length > 0 ? (
                  <div className="selected-products-summary">
                    {selectedProducts.map((productId) => {
                      const product = products.find((p) => p.id === productId);
                      if (!product) return null;

                      const quantity =
                        selectedProductQuantities[productId] || 1;
                      const price =
                        selectedProductPrices[productId] || product.price;

                      return (
                        <div
                          key={productId}
                          className="sku_info d-flex flex-column flex-sm-row gap-2 align-items-center mb-2"
                        >
                          <div className="d-flex align-items-center justify-content-center">
                            <img
                              src={product.thumbnail}
                              width="40px"
                              height="40px"
                              style={{
                                borderRadius: "8px",
                                objectFit: "cover",
                              }}
                              alt=""
                              className="img-thumbnail"
                            />
                          </div>
                          <div className="sku_info_text flex-grow-1 text-center text-sm-start">
                            <p
                              style={{ color: "rgba(23, 43, 77, 1)" }}
                              className="mb-1 text-break small"
                            >
                              {product.title || product.name}
                            </p>
                            <p className="mb-0 small">عدد {quantity}</p>
                          </div>
                          <div
                            className="sku_info_text flex-grow-1 text-center text-sm-end"
                            style={{ color: "rgba(89, 198, 201, 1)" }}
                          >
                            <p className="mb-1 small">{_("home.price")}</p>
                            <p className="mb-0 fw-bold small">
                              {price - (userData?.level_data?.commission ?? 0)}{" "}
                              {altName}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : cart.id ? (
                  <div className="sku_info d-flex flex-column flex-sm-row gap-2 align-items-center">
                    <div className="d-flex align-items-center justify-content-center">
                      <img
                        src={cart.thumbnail}
                        width="40px"
                        height="40px"
                        style={{
                          borderRadius: "8px",
                          objectFit: "cover",
                        }}
                        alt=""
                        className="img-thumbnail"
                      />
                    </div>
                    <div className="sku_info_text flex-grow-1 text-center text-sm-start">
                      <p
                        style={{ color: "rgba(23, 43, 77, 1)" }}
                        className="mb-1 text-break"
                      >
                        {cart.title}
                      </p>
                      <p className="mb-0 small">عدد {orderClientQuantity}</p>
                    </div>
                    <div
                      className="sku_info_text flex-grow-1 text-center text-sm-end"
                      style={{ color: "rgba(89, 198, 201, 1)" }}
                    >
                      <p className="mb-1">{_("home.price")}</p>
                      <p className="mb-0 fw-bold">
                        {orderClientPrice -
                          (userData?.level_data?.commission ?? 0)}{" "}
                        {altName}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <p className="text-muted mb-2">
                      {_("panel.selectProductToContinue")}
                    </p>
                    <Button
                      className=" border-0"
                      style={{
                        backgroundColor: "rgba(89, 198, 201, 1)",
                        color: "white",
                      }}
                      size="sm"
                      onClick={() => {
                        setShowProductModal(true);
                        setSelectedProducts([]);
                        setSelectedProductQuantities({});
                        setSelectedProductPrices({});
                        setSelectedProductVariants({});
                        fetchProducts(1, "");
                      }}
                     
                    >
                      {_("panel.selectProduct")}
                    </Button>
                  </div>
                )}
                <div className="pricing-info d-flex flex-column">
                  {role != "fulfillment" ? (
                    <>
                      <div className="price-row d-flex justify-content-between p-2 p-sm-3">
                        <p
                          className="fs-6 fs-sm-5"
                          style={{ color: "rgba(23, 43, 77, 1)" }}
                        >
                          {_("home.shippingcost")}
                        </p>
                        <p className="fs-6 fs-sm-5">
                          {shippingcost} {altName}
                        </p>
                      </div>
                      <div className="price-row d-flex justify-content-between p-2 p-sm-3">
                        <p
                          className="fs-6 fs-sm-5"
                          style={{ color: "rgba(23, 43, 77, 1)" }}
                        >
                          {_("home.tax")}
                        </p>
                        <p className="fs-6 fs-sm-5">0 {altName}</p>
                      </div>
                      <div className="price-row d-flex justify-content-between p-2 p-sm-3">
                        <p
                          className="fs-6 fs-sm-5"
                          style={{ color: "rgba(23, 43, 77, 1)" }}
                        >
                          {_("home.commission")}
                        </p>
                        <p className="fs-6 fs-sm-5">
                          {totalCommission} {altName}
                        </p>
                      </div>
                      <div className="price-row d-flex justify-content-between p-2 p-sm-3">
                        <p
                          className="fs-6 fs-sm-5"
                          style={{ color: "rgba(23, 43, 77, 1)" }}
                        >
                          {_("home.price")}
                        </p>
                        <p className="fs-6 fs-sm-5">
                          {totalPrice - totalCommission} {altName}
                        </p>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div className="price-row d-flex justify-content-between p-2 p-sm-3">
                    <p
                      className="fs-6 fs-sm-5"
                      style={{ color: "rgba(23, 43, 77, 1)" }}
                    >
                      {_("home.totalprice")}
                    </p>
                    <p className="fs-6 fs-sm-5">
                      {role == "fulfillment"
                        ? COD
                        : totalPrice + parseInt(shippingcost)}{" "}
                      {altName}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <Button
                style={{
                  backgroundColor:
                    cart.id || selectedProducts.length > 0
                      ? "rgba(89, 198, 201, 1)"
                      : "#ccc",
                  color: "white",
                  border: "none",
                  width: "100%",
                }}
                className="fs-5"
                disabled={!cart.id && selectedProducts.length === 0}
                onClick={() => {
                  placeOrder();
                }}
              >
                {cart.id || selectedProducts.length > 0
                  ? _("panel.addorder")
                  : _("panel.selectProductFirst")}
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Product Selection Modal */}
      <Modal
        show={showProductModal}
        onHide={() => {
          setShowProductModal(false);
          setSelectedProducts([]);
        }}
        size="xl"
        className="product-selection-modal"
        dialogClassName="modal-fullscreen-sm-down"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-break">
            {_("panel.selectProduct")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2 p-sm-3">
          <div className="mb-3">
            <Form.Label className="fw-bold">
              {_("panel.searchProduct")}
            </Form.Label>
            <div className="d-flex flex-column flex-sm-row gap-2">
              <Form.Control
                type="text"
                placeholder={_("panel.enterProductNameOrSku")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                className="flex-grow-1"
              />
              <Button
                 onClick={handleSearch}
                disabled={modalLoading}
                className="flex-shrink-0 border-0"
                style={{ minWidth: "80px" , backgroundColor: "rgba(89, 198, 201, 1)", color: "white" }}
              >
                {modalLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  _("panel.search")
                )}
              </Button>
            </div>
          </div>

          {modalLoading && (
            <div className="text-center py-4">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">{_("panel.loading")}</span>
              </Spinner>
              <p className="mt-2 text-muted">{_("panel.loading")}</p>
            </div>
          )}

          {!modalLoading && products.length > 0 && (
            <div className="table-responsive">
              <Table striped bordered hover className="mb-0 small">
                <thead>
                  <tr>
                    <th className="text-center" style={{ width: "40px" }}>
                      <Form.Check
                        type="checkbox"
                        checked={
                          selectedProducts.length ===
                            products.filter((p) => p.id && p.left > 0).length &&
                          products.filter((p) => p.id && p.left > 0).length > 0
                        }
                        onChange={(e) => handleSelectAll(e.target.checked)}
                        disabled={
                          products.filter((p) => p.id && p.left > 0).length ===
                          0
                        }
                      />
                    </th>
                    <th className="text-center" style={{ width: "60px" }}>
                      {_("panel.image")}
                    </th>
                    <th>{_("panel.productName")}</th> 
                    <th className="text-center">{_("panel.available")}</th>
                    
                  </tr>
                </thead>
                <tbody>
                  {products.map((product) => (
                    <tr key={product.id || `product-${Math.random()}`}>
                      <td className="text-center">
                        <Form.Check
                          type="checkbox"
                          checked={selectedProducts.includes(product.id)}
                          onChange={(e) =>
                            handleCheckboxChange(product.id, e.target.checked)
                          }
                          disabled={!product.id || product.left <= 0}
                        />
                      </td>
                      <td className="text-center">
                        {product.thumbnail ? (
                          <img
                            src={product.thumbnail}
                            alt={product.title || product.name}
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                            className="img-thumbnail"
                          />
                        ) : (
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              backgroundColor: "#f8f9fa",
                              borderRadius: "4px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <small className="text-muted">No img</small>
                          </div>
                        )}
                      </td>
                      <td>
                        <div className="d-flex flex-column">
                          <strong className="text-break">
                            {product.title || product.name}
                          </strong>
                          <small className="text-muted d-none d-sm-inline">
                            ID: {product.id}
                          </small>
                          <small className="text-muted d-sm-none">
                            {product.sku || "-"}
                          </small>
                        </div>
                      </td> 
                      <td className="text-center">
                        <span
                          className={`badge ${
                            product.left > 0 ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {product.left || 0}
                        </span>
                      </td> 
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}

          {!modalLoading && products.length === 0 && searchTerm && (
            <Alert variant="info" className="text-center">
              <i className="fas fa-search me-2"></i>
              {_("panel.noProductsFound")}
            </Alert>
          )}

          {!modalLoading && products.length === 0 && !searchTerm && (
            <Alert variant="info" className="text-center">
              <i className="fas fa-box me-2"></i>
              {_("panel.noProductsAvailable")}
            </Alert>
          )}

          {!modalLoading && products.length > 0 && totalPages > 1 && (
            <div className="d-flex justify-content-center mt-3">
              <Pagination className="flex-wrap">
                <Pagination.First
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                />
                <Pagination.Prev
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                />

                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  const page =
                    Math.max(1, Math.min(totalPages - 4, currentPage - 2)) + i;
                  return (
                    <Pagination.Item
                      key={page}
                      active={page === currentPage}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </Pagination.Item>
                  );
                })}

                <Pagination.Next
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                />
                <Pagination.Last
                  onClick={() => handlePageChange(totalPages)}
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column flex-sm-row justify-content-between gap-2">
          <div className="text-muted small text-center text-sm-start">
            {products.length > 0 && (
              <span>
                {_("panel.foundProducts")}: {products.length}
              </span>
            )}
            {selectedProducts.length > 0 && (
              <span className="ms-2">
                | {_("panel.selected")}: {selectedProducts.length}
              </span>
            )}
          </div>
          <div className="d-flex gap-2">
            <Button
              className="border-0"
              onClick={handleConfirmSelection}
              style={{
                backgroundColor: "rgba(89, 198, 201, 1)",
                color: "white",
              }}
              disabled={selectedProducts.length === 0}
            >
              {selectedProducts.length === 1
                ? _("panel.add")
                : _("panel.add")}
            </Button>
            <Button
              className="border-0 bg-secondary"
              
              onClick={() => {
                setShowProductModal(false);
                setSelectedProducts([]);
              }}
            >
              {_("panel.close")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AddOrderFulfillment;
